import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: '首页' },
  { to: '/category/works', label: '作品' },
  { to: '/category/news', label: '动态' },
  { to: '/profile', label: '简介' },
  { to: '/about', label: '关于' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActivePath = (to: string) => {
    const path = location.pathname;
    if (to === '/') return path === '/';
    if (to === '/category/works') return path.startsWith('/category/works') || path.startsWith('/detail/work');
    if (to === '/category/news') return path.startsWith('/category/news') || path.startsWith('/detail/news');
    return path.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="w-full flex items-center justify-between px-4 md:px-8 h-16">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer" onClick={() => setOpen(false)}>
          <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg">优</span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg text-foreground-950 tracking-wide">小仓优子</span>
            <span className="text-[10px] tracking-[0.25em] text-secondary-700 mt-0.5">OGURA YUKO</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={() =>
                `px-4 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  isActivePath(item.to)
                    ? 'text-accent-600 font-medium'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/profile"
            className="ml-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            人物档案
          </Link>
        </nav>

        <button
          type="button"
          aria-label="打开菜单"
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`ri-${open ? 'close-line' : 'menu-line'} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={() =>
                  `px-3 py-3 text-sm rounded-md transition-colors cursor-pointer ${
                    isActivePath(item.to) ? 'text-accent-600 font-medium bg-accent-50' : 'text-foreground-700 hover:bg-primary-50'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}